import { QuestionType, questionsObj } from "../Data/questions"
import { evaluationStageType } from "../Models/EvaluationStageType"

//These functions are for handling differences and handle logic based on,
//what type of evaluation is currently active.

export const determineQuestionsArr = (evaluationStage: evaluationStageType) => {
    let questionsArr: QuestionType[]

    if (evaluationStage === "beforeFull" || evaluationStage === "afterFull") {
        questionsArr = questionsObj.full
    } else {
        questionsArr = questionsObj.light
    }

    return questionsArr
}

export const startButtonText = (evaluationStage: evaluationStageType, polyglot:any) => {
    let buttonText = ""
    if (evaluationStage === "beforeLight" || evaluationStage === "beforeFull") {
        buttonText = polyglot.t("evaluationTool.evaluationStart.startBtnBefore")
    } else if (evaluationStage === "afterLight" || evaluationStage === "afterFull") {
        buttonText = polyglot.t("evaluationTool.evaluationStart.startBtnAfter")
    }

    return buttonText
}
